<template>
  <div>
    <div>
      <h1>Please Try Again</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CheckoutFailure',
  props: [],
  methods: {
  },
  data() {
    return {
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/schools/CheckoutFailure.vue